import { RootState } from "@/store";
import { createSelector } from "@reduxjs/toolkit";
import { AlertMessage } from "./alertsTypes";

// Basic selectors
export const selectAlerts = (state: RootState) => state.alerts.alerts;
export const selectMaxAlerts = (state: RootState) => state.alerts.maxAlerts;
export const selectAlertsState = (state: RootState) => state.alerts;

// Derived selectors
export const selectAlertsByStatus = createSelector(
  [selectAlerts, (_, status: number) => status],
  (alerts, status) =>
    alerts.filter((alert: AlertMessage) => alert.status === status)
);

export const selectErrorAlerts = createSelector([selectAlerts], (alerts) =>
  alerts.filter((alert: AlertMessage) => alert.status >= 400)
);

export const selectSuccessAlerts = createSelector([selectAlerts], (alerts) =>
  alerts.filter(
    (alert: AlertMessage) => alert.status >= 200 && alert.status < 300
  )
);

export const selectInfoAlerts = createSelector([selectAlerts], (alerts) =>
  alerts.filter(
    (alert: AlertMessage) => alert.status >= 100 && alert.status < 200
  )
);

export const selectAutoCloseAlerts = createSelector([selectAlerts], (alerts) =>
  alerts.filter((alert: AlertMessage) => alert.autoClose)
);
